import React, { useState } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Message from '../Message/Message';
import Modal from '../Modal/Modal';
import styles from './MessageGroup.module.css';

const MessageGroup = ({ messages, cols, authorFontSize, msgFontSize }) => {
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [closedMessages, setClosedMessages] = useState([]);
  const [modalContent, setModalContent] = useState(null);

  const closeHandler = (id) => {
    if (closedMessages.includes(id)) {
      setClosedMessages(closedMessages.filter((item) => item !== id));
    } else if (selectedMessage !== id) {
      setClosedMessages([...closedMessages, id]);
    }
  };

  const selectHandler = (id) => {
    if (selectedMessage === id) {
      setSelectedMessage(null);
    } else {
      if (closedMessages.includes(id)) {
        setClosedMessages(closedMessages.filter((item) => item !== id));
      }
      setSelectedMessage(id);
    }
  };

  const resetSelectHandler = (id) => {
    if (selectedMessage !== id && selectedMessage) {
      setSelectedMessage(null);
    }
  };

  return (
    <TransitionGroup
      className={styles.wrapper}
      style={{ gridTemplateColumns: `repeat(${cols}, minmax(10rem, 100rem))` }}>
      {messages &&
        messages.map((msg) => (
          <CSSTransition key={msg.id} timeout={500} classNames="fade-scale">
            <Message
              key={msg.id}
              message={msg.message}
              closeHandler={closeHandler}
              selectHandler={selectHandler}
              isSelected={
                selectedMessage ? selectedMessage === msg.message.id : true
              }
              isClosed={closedMessages.includes(msg.message.id)}
              resetSelectHandler={resetSelectHandler}
              setModalContent={setModalContent}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
            />
          </CSSTransition>
        ))}
      <Modal isOpen={modalContent} closeModal={() => setModalContent(null)}>
        <img src={modalContent} alt="" className={styles.modalImg} />
      </Modal>
    </TransitionGroup>
  );
};

export default MessageGroup;
